import ParamsEditor from './shared/ParamsEditor';

interface ImgixParams {
  [key: string]: any;
}

interface HeroParamsEditorProps {
  defaultParams: any;
  originalCode: string;
  onParamsChange: (params: any, editorContent?: string) => void;
  currentImageSetId?: string | null;
}

function HeroParamsEditor({ defaultParams, originalCode, onParamsChange, currentImageSetId }: HeroParamsEditorProps) {
  return (
    <ParamsEditor
      title="Hero Image Parameters"
      titleKey="hero_parameters"
      defaultParams={defaultParams}
      originalCode={originalCode}
      onParamsChange={onParamsChange}
      currentImageSetId={currentImageSetId}
      storageKeyPrefix="heroEditorContent_"
      className="mb-6"
    />
  );
}

export default HeroParamsEditor;